import { render } from "./pc_property_list.vue?vue&type=template&id=68d59a46&scoped=true"
import script from "./pc_property_list.vue?vue&type=script&scoped=true&lang=js"
export * from "./pc_property_list.vue?vue&type=script&scoped=true&lang=js"

import "./pc_property_list.vue?vue&type=style&index=0&id=68d59a46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d59a46"]])

export default __exports__